import PropTypes from 'prop-types';
import React from 'react';

const SimplifiedLogsViewer = ({ logText }) => {
  const outputStyle = {
    padding: '15px',
    backgroundColor: 'white',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
    maxHeight: '200px',
    overflowY: 'auto',
    color: 'black',
    ':hover': {
      backgroundColor: '#3d3d3d'
    }
  };
  const fullResponseStyle = {
    ...outputStyle,
    maxHeight: '200px',
    maxWidth: '600px',
    backgroundColor: 'white',
    color: 'black'
  };
  const preStyle = {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    backgroundColor: 'white',
    color: 'black',
    fontFamily: 'monospace',
    lineHeight: '1.5',
    fontSize: 12,
    fontStyle: 'normal',
    overflow: 'hidden',
    fontWeight: 400
  };
  return (
    <div style={fullResponseStyle}>
      <div style={preStyle}>{logText || 'No Simplified Logs are available!'}</div>
    </div>
  );
};

SimplifiedLogsViewer.propTypes = {
  logText: PropTypes.string.isRequired
};

export default SimplifiedLogsViewer;
